module.exports = __webpack_public_path__ + "img/generating.0e985ab1.gif";